import * as React from "react";
function SvgFacebookReactionLike(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <circle cx={24} cy={23.94} r={16} fill="#fff" />
      <path
        d="M24 0a24 24 0 1024 24A24 24 0 0024 0zm-6.57 34.43a.75.75 0 01-.75.75h-4.23a.75.75 0 01-.75-.75V22.3a.75.75 0 01.75-.75h4.23a.75.75 0 01.75.75zm18.1-8.49a1.94 1.94 0 01-1.46 1.88 1.7 1.7 0 01-.42 3.18 1.7 1.7 0 01-1 3H19.88a1.3 1.3 0 01-1.09-1.36v-7.82a9.8 9.8 0 011.5-5.47A25.8 25.8 0 0123 15.94a5.34 5.34 0 001.5-2.23v-1.57a1.64 1.64 0 011.6-1.68h.12a1.59 1.59 0 011.37.59 5.44 5.44 0 011 3.68c0 1.75-1.89 5.44-1.89 5.44h6.82a2.2 2.2 0 012.12 2.22 2.23 2.23 0 01-1 1.88 1.94 1.94 0 01.89 1.67z"
        fill="#6d98ce"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFacebookReactionLike);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
